function findColumnOrder(queryOrder, fieldName) {

    return (queryOrder || []).find((item) => (item.ident || item.fieldName) == fieldName) || null;

}

function createColumn(columnDef, queryOrder = []) {

    const order = columnDef.fieldName
        ? findColumnOrder(queryOrder, columnDef.fieldName)
        : null;

    return Object.assign({}, columnDef, { order });

}

function createColumns(columnDefs = [], queryOrder = []) {

    return (columnDefs || []).map((columnDef) => createColumn(columnDef, queryOrder));

}

function createColumnDefFromField(field) {

    return {
        field,
        fieldName: field.name || '?',
        label: field.label,
        orderable: field.orderable || false,
        width: field.width || null,
        alignment: field.alignment || null,
        format: field.format || null,
    };

}

function resolveFieldFromReference(dataModel, fieldReference) {

    if (!fieldReference)
        return null;

    if (typeof fieldReference == 'object')
        return fieldReference;

    const fields = (dataModel && dataModel.getFields && dataModel.getFields()) || [];
    const field = fields.find((item) => item && item.name == fieldReference) || null;

    if (!field)
        throw new Error(`[data-browser-helpers] Unknown field "${fieldReference}".`);

    return field;

}

function createColumnDefsFromModel(dataModel) {

    const fields = (dataModel && dataModel.getFields && dataModel.getFields()) || [];

    return fields
        .filter((field) => field && field.inBrowser)
        .map((field) => createColumnDefFromField(field));

}

function createColumnDefsFromFieldNames(dataModel, fieldNames = []) {

    const fields = (fieldNames || []).map((fieldReference) => resolveFieldFromReference(dataModel, fieldReference));
    return fields.map((field) => createColumnDefFromField(field));

}

function createColumnsFromModel(dataModel, queryOrder = []) {

    return createColumns(createColumnDefsFromModel(dataModel), queryOrder);

}

export {
    createColumn,
    createColumns,
    createColumnDefFromField,
    createColumnDefsFromFieldNames,
    createColumnDefsFromModel,
    createColumnsFromModel,
};
